export default __webpack_public_path__ + "images/LY.c2bff36.png";